import { Fragment } from "react";

import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { getColor } from "@atlassiansox/wpl-utils";

import {
    FormattedPriceCalculationResponse,
    PriceFinderMessages
} from "../constants";

import { centerJustifiedStyling } from "./card-container";
import { PriceDisplay } from "./price-display";

const monthlyContainerStyles = css(centerJustifiedStyling);

const perUserTextStyles = css({
    fontSize: "16px",
    lineHeight: "24px"
});

const perMonthTextStyles = css({
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: "bold",
    marginBlockEnd: "32px",
    color: getColor("n900")
});

export type MonthlyProps = {
    readonly priceCalc: FormattedPriceCalculationResponse;
    readonly fontSize: string;
    readonly planName: string;
    readonly messages: PriceFinderMessages;
};

export const Monthly = ({
    priceCalc,
    fontSize,
    planName,
    messages
}: MonthlyProps) => {
    const { formattedTotalPrice, formattedAvgPerUnitPrice } = priceCalc;

    return (
        <Fragment>
            <PriceDisplay
                planName={planName}
                formattedPrice={formattedAvgPerUnitPrice}
                fontSize={fontSize}
            />
            <div css={monthlyContainerStyles}>
                <div css={perUserTextStyles}>
                    <FormattedMessage {...messages.cardMonthlyPerUnitCount} />
                </div>
                <div css={perMonthTextStyles}>
                    <FormattedMessage
                        id="Pricing.PriceCard.Monthly.PerMonthText"
                        defaultMessage="{formattedTotalPrice} per month"
                        values={{ formattedTotalPrice }}
                    />
                </div>
            </div>
        </Fragment>
    );
};
